import React from 'react'
import {Link, useResolvedPath, useMatch} from "react-router-dom"
import {MenuItem} from 'react-pro-sidebar'
const SideLink = ({children, to,activeClass, ...props }) => {
    let resolved = useResolvedPath(to);
    let match = useMatch({ path: resolved.pathname, end: true });
    return (
        <MenuItem className={match? activeClass:""}  {...props}>
        {children}
        <Link
          style={{ textDecoration: match ? "underline" : "none" }}
          to={to}
          />
      </MenuItem>
    )
}

export default SideLink

// function CustomLink({ children, to, ...props }: LinkProps) {
//     let resolved = useResolvedPath(to);
//     let match = useMatch({ path: resolved.pathname, end: true });
  
//     return (
//       <div>
//         <Link
//           style={{ textDecoration: match ? "underline" : "none" }}
//           to={to}
//           {...props}
//         >
//           {children}
//         </Link>
//         {match && " (active)"}
//       </div>
//     );